import React, { useCallback } from "react";
import { Radio } from "@alm/flow-ds/components";
import { CommonPropertyProps } from "schemas/elements";
import { useTranslation } from "react-i18next";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: string;
};

export default ({
	updateStore,
	field,
	value,
	desc,
	elementIndex,
	id,
}: Props) => {
	const { t } = useTranslation();
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			updateStore({
				elementIndex,
				property: field,
				value: e.target.value,
			});
		},
		[elementIndex, field, updateStore]
	);

	return (
		<Radio
			id={id}
			options={
				field === "searchOperator"
					? [
							{
								value: "contains",
								label: t("formDesigner.labels.contains"),
							},
							{
								value: "exact",
								label: t("formDesigner.labels.exact"),
							},
					  ]
					: [
							{
								value: "int",
								label: t("formDesigner.labels.int"),
							},
							{
								value: "decimal",
								label: t("formDesigner.labels.decimal"),
							},
					  ]
			}
			value={value}
			onChange={handleChange}
			label={t(`formDesigner.properties.${field}`)}
			hint={t(`formDesigner.elements.${desc}`)}
		/>
	);
};
